{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/latest-comments",
	"title": "Latest Comments",
	"category": "widgets",
	"description": "Display a list of your most recent comments.",
	"keywords": [ "recent comments" ],
	"textdomain": "default",
	"attributes": {
		"commentsToShow": {
			"type": "number",
			"default": 5,
			"minimum": 1,
			"maximum": 100
		},
		"displayAvatar": {
			"type": "boolean",
			"default": true
		},
		"displayDate": {
			"type": "boolean",
			"default": true
		},
		"displayContent": {
			"type": "string",
			"default": "excerpt",
			"enum": [ "none", "excerpt", "full" ]
		}
	},
	"supports": {
		"anchor": true,
		"align": true,
		"color": {
			"gradients": true,
			"link": true,
			"__experimentalDefaultControls": {
				"background": true,
				"text": true,
				"link": true
			}
		},
		"html": false,
		"spacing": {
			"margin": true,
			"padding": true
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"interactivity": {
			"clientNavigation": true
		}
	},
	"style": "wp-block-latest-comments"
}
